import { Button, Tooltip } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';

import { useThemeStore } from '../store/themeStore';

/**
 * Sun/moon switcher for the app header. The icon previews the destination: a sun in dark mode
 * ("switch to light"), a moon in light mode ("switch to dark"). Flipping the store swaps the
 * antd algorithm app-wide (see App/buildAntdTheme).
 */
const ThemeToggle = () => {
  const mode = useThemeStore((state) => state.mode);
  const toggle = useThemeStore((state) => state.toggle);

  const isDark = mode === 'dark';
  const label = isDark ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <Tooltip title={label}>
      <Button
        type="text"
        aria-label={label}
        icon={isDark ? <SunOutlined /> : <MoonOutlined />}
        onClick={toggle}
        data-testid="sa-theme-toggle"
      />
    </Tooltip>
  );
};

export default ThemeToggle;
